export enum SlotTypes {
  coin_bag = 'coin_bag',
  treasure = 'treasure',
  // multiplier_x2 = 'multiplier_x2',
  // multiplier_x3 = 'multiplier_x3',
  // multiplier_x5 = 'multiplier_x5',
  energy_refill = 'energy_refill',
  revive = 'revive',
  aviator = 'aviator',
  launch_chest = 'launch_chest',
  orbit_chest = 'orbit_chest',
  galaxy_chest = 'galaxy_chest',
  supernova_chest = 'supernova_chest',
  rocket_coins = 'rocket_coins_bonus',
}

export const RewardsType = {
  REGULAR: 'regular',
  LEAGUE_UPDATE: 'league_update',
  CHARACTER_UPDATE: 'character_update',
};
